<template lang="pug">
Paginate(
  v-model="localCurrectPage"
  active-class="tableTop10-linkPagination--active"
  :click-handler="changePage"
  :page-count="pageCount"
  :margin-pages="0"
  :page-range="pageRange"
  container-class='tableTop10-pagination'
  page-class='tableTop10-itemPagination'
  page-link-class='tableTop10-linkPagination'
  prev-class='tableTop10-arrowLeft'
  prev-link-class='icon-pagination-left'
  prev-text=''
  next-class='tableTop10-arrowRight'
  next-link-class="icon-pagination-right"
  next-text=''
  :first-last-button="false"
)
</template>

<script>
import Paginate from "vuejs-paginate";
export default {
  props: {
    pageCount: Number,
    currentPage: Number
  },
  data() {
    return {
      localCurrectPage: this.currentPage
    }
  },
  components: {
    Paginate
  },
  methods: {
    changePage() {
      this.$emit("changePage", this.localCurrectPage);
    }
  },
  computed: {
    pageRange() {
      if (this.localCurrectPage < 3 || (this.pageCount - this.localCurrectPage) < 2)
        return 4;
      return 3;
    }
  }
};
</script>
